import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageHeader from "../../components/shared/PageHeader";
import PageMain from "../../containers/shared/PageMain";
import MainContent from "../../containers/shared/MainContent";
import apiClient from "../../components/utils/apiClient";
import moment from "moment";
import { UserContext } from "../../App";

const PerventiveVisitsSinglePage = () => {
    const { id } = useParams();
    const {t,i18n} = useTranslation();
    useDocumentTitle('الصيانة الوقائية');
    const pageTitle = {title: 'الصيانة الوقائية', subTitle: 'تفاصيل طلب صيانة وقائية '};

    const [singlePerventiveVisit, setSinglePerventiveVisit] = useState(null);
    const [reports, setReports] = useState(null);

    const { businessPackage } = useContext(UserContext);
    

    const getPerventiveVisits = async () => {
      try {
        const response = await apiClient.get(`/b-preventive-visits/${id}`);

        if(response?.data) {
            setSinglePerventiveVisit(response?.data);
        } else {

        }
      } catch(err) {}
    }

    const getReports = async () => {
      try {
        const response = await apiClient.get(`/b-visits/${singlePerventiveVisit?._id}/export-report`);

        if(response?.data) {
            setReports(response?.data);
        } else {
            setReports([]);
        }
      } catch(err) {setReports([]);}
    }


    useEffect(()=>{
        if(id) {
            getPerventiveVisits();
        }
    },[id])

    useEffect(()=>{
        if(singlePerventiveVisit) {
            getReports();
        }
    },[singlePerventiveVisit])


  const getFieldName = (field) => {
        switch(field) {
            case 'air-conditioning':
                return 'التكييف';
            case 'plumbing':
                return 'السباكة';
            case 'electrical':
                return 'الكهرباء';
            case 'elevators':
                return 'المصاعد';
            case 'fire & safety':
                return 'الأمن و السلامة';
            default:
                return '';
        }
    }

  
  return (
    <div>
      <PageHeader pageTitle={pageTitle} />
      <PageMain>
        <div className="absolute top-0 left-0 w-full h-[15px] bg-grey-50 z-0"></div>
        <MainContent>
          <div className="pt-[15px]">
            

            <div className="rounded-[24px] border-[1px] border-grey-300 p-[24px] mb-[25px]">
                <h2 className="text-darkBlue text-[24px] font-[700] mb-[25px]">تفاصيل الطلب</h2>
                <div className="flex flex-nowrap border-b-[1px] border-b-grey-200 leading-[50px] mb-[5px]">
                    <div className="w-[50%] text-[14px] font-[700] text-grey-900">
                        الخدمة المطلوبة
                    </div>
                    <div className="w-[50%] text-end text-[16px] font-[500] text-grey-600">
                        {getFieldName(singlePerventiveVisit?.field)}
                    </div>
                </div>
                <div className="flex flex-nowrap border-b-[1px] border-b-grey-200 leading-[50px] mb-[5px]">
                    <div className="w-[50%] text-[14px] font-[700] text-grey-900">
                        الوحدة
                    </div>
                    <div className="w-[50%] text-end text-[16px] font-[500] text-grey-600">
                        {singlePerventiveVisit?.units[0]?.name} <span className="text-grey-500">{`(${singlePerventiveVisit?.units[0]?.property?.name})`}</span>
                    </div>
                </div>
                <div className="flex flex-nowrap border-b-[1px] border-b-grey-200 leading-[50px] mb-[5px]">
                    <div className="w-[50%] text-[14px] font-[700] text-grey-900">
                        تاريخ أول زيارة
                    </div>
                    <div className="w-[50%] text-end text-[16px] font-[500] text-grey-600">
                        {moment(singlePerventiveVisit?.startingDate).format('DD/MM/YYYY')}
                    </div>
                </div>
                <div className="flex flex-nowrap border-b-[1px] border-b-grey-200 leading-[50px] mb-[5px]">
                    <div className="w-[50%] text-[14px] font-[700] text-grey-900">
                        عدد الزيارات في السنة
                    </div>
                    <div className="w-[50%] text-end text-[16px] font-[500] text-grey-600">
                        {singlePerventiveVisit?.packageDetails?.fieldPrice?.visitsPerYear} زيارة
                    </div>
                </div>
                <div className="flex flex-nowrap leading-[50px] mb-[-15px]">
                    <div className="w-[50%] text-[14px] font-[700] text-grey-900">
                        السعر
                    </div>
                    <div className="w-[50%] text-end text-[16px] font-[500] text-grey-600">
                        {singlePerventiveVisit?.packageDetails?.fieldPrice?.includedUnitPrice} <span className="inline-block w-[13px] h-[13px] align-middle" style={{background:"url('/assets/images/SAR-mini.svg')"}}></span>
                    </div>
                </div>
            </div>

            <div className="mb-[25px]">
                <h1 className="text-darkBlue font-[700] text-[24px]">تقارير الزيارات</h1>
            </div>
            
            <div className="rounded-[24px] border-[1px] border-grey-300 p-[24px] mb-[25px]">
        
                <div className="text-center">لاتوجد تقارير.</div>

            </div>

          </div>
        </MainContent>
      </PageMain>



    </div>
  );
};

export default PerventiveVisitsSinglePage;
